import "core-js";
import "regenerator-runtime/runtime";
import './learn-css';

import Sortable from 'sortablejs';

// Make Sortable available globally for angular-legacy-sortablejs-maintained.
// TODO Find a less awful way to import this.
// window.Sortable = Sortable;
// console.log('Sortable.create?', Sortable.create);

/*
 * Learn Angular Application
 */
(function() {
  const angular = require('angular');

  var setupApp = angular.module('learn-app-setup', ['ng']);
  setupApp.provider('appConfiguration', function() {
    var configurationData;

    this.initialize = function(data) {
      configurationData = data;
    };

    this.$get = function() {
      return configurationData;
    };
  });

  //moved this above the base requirements to allow the angulartics modules to hook int other modules as much as possible per the documentation. Potentially useless, but difficult to validate. 
  var app = angular.module('learn-app', ['ngRoute', 'ngCookies', 'ngSanitize', 'ngTouch', 'learn-app-setup', 'learn-resources', 'learn-services', 'learn-controllers', 'learn-directives', 'learn-i18n-l10n', 'angular-medium-editor', 'ngFileUpload', 'chart.js', 'mentio', '720kb.datepicker', 'froala', 'ng-sortable']);

  require('angular-route');
  require('angular-cookies');
  require('angular-sanitize');
  require('angular-touch');
  require('./learn-resources');
  require('./learn-services');
  require('./learn-controllers');
  require('./learn-directives');
  require('./learn-i18n-l10n');

  require('./vendor/angular-legacy-sortablejs/angular-legacy-sortable');
  require('./vendor/angular-froala/angular-froala');
  require('./vendor/angular-froala/froala-sanitize');
  window.MediumEditor = require('medium-editor');
  require('../../node_modules/angular-medium-editor/dist/angular-medium-editor.min');
  require('../../node_modules/ng-file-upload/dist/ng-file-upload.min');
  require('./vendor/angular-chart');
  require('../../node_modules/ment.io/dist/mentio.min');
  require('../../node_modules/angularjs-datepicker/dist/angular-datepicker.min');

  /**
   * Adds a global error handler decorator to Angular's $provide
   * @argument {Object} $provide The generic provider object in Angular
   */
  app.config(['$provide',function logExceptionToNewRelic ($provide) {
    // Provide an interceptor for the error workflow.
    $provide.decorator("$exceptionHandler", ['$delegate', function ($delegate) {

      // Return the new $exceptionHandler implementation which will
      // report the error to our internal error handler before passing
      // it off to the original $exceptionHandler implementation (which
      // may, itself, be some other delegate provided by another part
      // of the application).
      return function (error, cause) {
        console.error(error);
        newrelic.noticeError(error, { "cause": cause });
        $delegate(error, cause);
      };
    }]);
  }]);

  /**
   * Configures ngRoute's $routeProvider with the routes we have in the Application
   * @argument {Object} $routeProvider The object from ngRoute to configure routes
   */
  app.config(['$routeProvider', function($routeProvider) {
    var universalResolves = {
      "translationReadierZZZZZZZ": ['$translate', function($translate) {
        try {
          return $translate.onReady();
        } catch(e) {
          console.log('Resolver failed to ready', e);
          return true;
        }
      }]
    };

    var customRouteProvider = angular.extend({}, $routeProvider, {
      when: function(path, route) {
        route.resolve = (route.resolve) ? route.resolve : {};
        angular.extend(route.resolve, universalResolves);
        $routeProvider.when(path, route);
        return this;
      }
    });

    function makeExternalLearnerAppContentTypeResolveRedirector(contentType) {
      return ['Features', 'Storage', 'UrlLookup', '$route', '$window', function(Features, Storage, UrlLookup, $route, $window) {
        try {
          if (Features.useExternalLearner()) {
            Storage.put('transferring', UrlLookup.viewContentType(contentType, $route.current.params.id));
            return '/please-wait-transferring';
          }
        }
        catch (e) {
          console.log('redirectTo failed', e);
        }
        return undefined;
      }];
    }

    function makeExternalLearnerAppCreateContentTypeResolveRedirector(contentType) {
      return ['Features', 'Storage', 'UrlLookup', '$route', '$window', function(Features, Storage, UrlLookup, $route, $window) {
        try {
          if (Features.useExternalLearner()) {
            Storage.put('transferring', UrlLookup.createContentType(contentType, $route.current.params.id));
            return '/please-wait-transferring';
          }
        }
        catch (e) {
          console.log('redirectTo failed', e);
        }
        return undefined;
      }];
    }

    function makeExternalLearnerAppResolveRedirector(urlLookupFunction, usePublicRoute) {
      return ['Features', 'Storage', 'UrlLookup', '$window', function(Features, Storage, UrlLookup, $window) {
        try {
          if (Features.useExternalLearner()) {
            Storage.put('transferring', UrlLookup[urlLookupFunction]());
            if (usePublicRoute) {
              return '/please-wait-transferring-public';
            }
            return '/please-wait-transferring';
          }
        }
        catch (e) {
          console.log('redirectTo failed', e);
        }
        return undefined;
      }];
    }

    function makeExternalLearnerAppAdminSettingsResolveRedirector() { 
      return ['Features', 'Storage', 'UrlLookup', '$route', '$window', function(Features, Storage, UrlLookup, $route, $window) {
        const type = $route.current.params.type;

        try {
          if (Features.useExternalLearner() && type !== 'integrations') {
            Storage.put('transferring', UrlLookup.viewAdminSettings(type));
            return '/please-wait-transferring';
          }
        }
        catch (e) {
          console.log('redirectTo failed', e);
        }
        return undefined;
      }];
    }

    function makeExternalLearnerAppAdminReportsResolveRedirector() { 
      return ['Features', 'Storage', 'UrlLookup', function(Features, Storage, UrlLookup) {
        try {
          if (Features.useExternalLearner()) {
            Storage.put('transferring', UrlLookup.reports());
            return '/please-wait-transferring';
          }
        }
        catch (e) {
          console.log('redirectTo failed', e);
        }
        return undefined;
      }];
    }

    function makeExternalLearnerAppAdminUsersResolveRedirector(type) { 
      return ['Features', 'Storage', 'UrlLookup', '$route', '$window', function(Features, Storage, UrlLookup, $route, $window) {
        const id = $route.current.params.id;

        try {
          if (Features.useExternalLearner()) {
            Storage.put('transferring', UrlLookup.viewAdminUsers(type, id));
            return '/please-wait-transferring';
          }
        }
        catch (e) {
          console.log('redirectTo failed', e);
        }
        return undefined;
      }];
    }

      var defaultTitle = 'Continu';

      customRouteProvider.
          when('/home', {
            template: require('../templates/partials/home.html'),
            title: 'Home'
          }).
          when('/explore/:category?', {
            template: require('../templates/partials/explore.html'),
            title: defaultTitle + ' :: Explore',
            reloadOnUrl: false,
            resolveRedirectTo: makeExternalLearnerAppResolveRedirector('explore')
          }).
          when('/people', {
            template: require('../templates/partials/explore.html'),
            title: defaultTitle + ' :: People',
            reloadOnUrl: false,
            resolveRedirectTo: makeExternalLearnerAppResolveRedirector('people')
          }).
          when('/view/articles/:id', {
            template: require('../templates/partials/view-article.html'),
            title: defaultTitle,
            resolveRedirectTo: makeExternalLearnerAppContentTypeResolveRedirector('article')
          }).
          when('/view/videos/:id', {
            template: require('../templates/partials/view-video.html'),
            title: defaultTitle,
            resolveRedirectTo: makeExternalLearnerAppContentTypeResolveRedirector('video')
          }).
          when('/view/files/:id', {
            template: require('../templates/partials/view-file.html'),
            title: defaultTitle,
            resolveRedirectTo: makeExternalLearnerAppContentTypeResolveRedirector('file')
          }).
          when('/view/imported-content/:id', {
            template: require('../templates/partials/view-imported-content.html'),
            title: defaultTitle,
            resolveRedirectTo: makeExternalLearnerAppContentTypeResolveRedirector('imported-content')
          }).
          when('/view/presentations/:id', {
            template: require('../templates/partials/view-presentation.html'),
            title: defaultTitle,
            resolveRedirectTo: makeExternalLearnerAppContentTypeResolveRedirector('presentation')
          }).
          when('/view/presentations/:id/slides', {
            template: require('../templates/partials/view-presentation-inner.html'),
            title: defaultTitle,
            reloadOnSearch: false,
            resolveRedirectTo: makeExternalLearnerAppContentTypeResolveRedirector('presentation')
          }).
          when('/view/scorm/:id', {
            template: require('../templates/partials/view-scorm.html'),
            title: defaultTitle,
            resolveRedirectTo: makeExternalLearnerAppContentTypeResolveRedirector('scorm')
          }).
          when('/view/journey/:id', {
            template: require('../templates/partials/view-journey.html'),
            title: defaultTitle + ' :: View Journey',
            resolveRedirectTo: makeExternalLearnerAppContentTypeResolveRedirector('journey')
          }).
          when('/view/tracks/:id', {
            template: require('../templates/partials/view-track.html'),
            title: defaultTitle,
            resolveRedirectTo: makeExternalLearnerAppContentTypeResolveRedirector('track')
          }).
          when('/view/tracks/:trackId/:trackType/:id', {
            template: require('../templates/partials/view-track-inner.html'),
            title: defaultTitle,
            reloadOnUrl: false,
            resolveRedirectTo: makeExternalLearnerAppContentTypeResolveRedirector('track')
          }).
          when('/track-inner-view', {
            template: require('../templates/partials/view-track-inner.html'),
            title: defaultTitle
          }).
          when('/view/workshops/:id', {
            template: require('../templates/partials/view-workshop.html'),
            title: defaultTitle,
            reloadOnSearch: false,
            resolveRedirectTo: makeExternalLearnerAppContentTypeResolveRedirector('workshop')
          }).
          when('/view/survey/:id', {
            template: require('../templates/partials/view-survey.html'),
            title: defaultTitle + ' :: View Survey',
            reloadOnSearch: false,
            resolveRedirectTo: makeExternalLearnerAppContentTypeResolveRedirector('survey')
          }).
          when('/edit/access-profile', {
            template: require('../templates/partials/edit-access-profile.html'),
            title: defaultTitle + ' :: Edit Access Profile'
          }).
          when('/edit/access-profile/:id', {
            template: require('../templates/partials/edit-access-profile.html'),
            title: defaultTitle + ' :: Edit Access Profile'
          }).
          when('/view/assessments/:id', {
            template: require('../templates/partials/view-assessment.html'),
            title: defaultTitle + ' :: View Assessment',
            reloadOnSearch: false,
            resolveRedirectTo: makeExternalLearnerAppContentTypeResolveRedirector('assessment')
          }).
          when('/grade/assessments/:id', {
            template: require('../templates/partials/grade-assessment.html'),
            title: defaultTitle + ' :: Grade Assessment',
            reloadOnSearch: false
          }).
          when('/edit/articles', {
            template: require('../templates/partials/edit-article.html'),
            title: defaultTitle + ' :: Edit Article',
            resolveRedirectTo: makeExternalLearnerAppCreateContentTypeResolveRedirector('articles')
          }).
          when('/edit/articles/:id', {
            template: require('../templates/partials/edit-article.html'),
            title: defaultTitle + ' :: Edit Article',
            resolveRedirectTo: makeExternalLearnerAppCreateContentTypeResolveRedirector('articles')
          }).
          when('/edit/videos', {
            template: require('../templates/partials/edit-video.html'),
            title: defaultTitle + ' :: Edit Video',
            resolveRedirectTo: makeExternalLearnerAppCreateContentTypeResolveRedirector('videos')
          }).
          when('/edit/videos/:id', {
            template: require('../templates/partials/edit-video.html'),
            title: defaultTitle + ' :: Edit Video',
            resolveRedirectTo: makeExternalLearnerAppCreateContentTypeResolveRedirector('videos')
          }).
          when('/edit/files', {
            template: require('../templates/partials/edit-file.html'),
            title: defaultTitle + ' :: Edit File',
            resolveRedirectTo: makeExternalLearnerAppCreateContentTypeResolveRedirector('files')
          }).
          when('/edit/files/:id', {
            template: require('../templates/partials/edit-file.html'),
            title: defaultTitle + ' :: Edit File',
            resolveRedirectTo: makeExternalLearnerAppCreateContentTypeResolveRedirector('files')
          }).
          when('/edit/imported-content', {
            template: require('../templates/partials/edit-imported-content.html'),
            title: defaultTitle + ' :: Edit Course',
            resolveRedirectTo: makeExternalLearnerAppCreateContentTypeResolveRedirector('imported-content')
          }).
          when('/edit/imported-content/:id', {
            template: require('../templates/partials/edit-imported-content.html'),
            title: defaultTitle + ' :: Edit Course',
            resolveRedirectTo: makeExternalLearnerAppCreateContentTypeResolveRedirector('imported-content')
          }).
          when('/edit/journeys/:id?', {
            template: require('../templates/partials/edit-journey.html'),
            title: defaultTitle + ' :: Edit Journey',
            reloadOnUrl: false
          }).
          when('/edit/scorm/:id?', {
            template: require('../templates/partials/edit-scorm.html'),
            title: defaultTitle + ' :: Edit Scorm',
            reloadOnUrl: false,
            resolveRedirectTo: makeExternalLearnerAppCreateContentTypeResolveRedirector('scorm')
          }).
          when('/edit/access-profiles', {
            template: require('../templates/partials/edit-access-profile.html'),
            title: defaultTitle + ' :: Edit Access Profile'
          }).
          when('/edit/access-profiles/:id', {
            template: require('../templates/partials/edit-access-profile.html'),
            title: defaultTitle + ' :: Edit Access Profile'
          }).
          when('/edit/assessments', {
            template: require('../templates/partials/edit-assessment.html'),
            title: defaultTitle + ' :: Edit Assessment',
            resolveRedirectTo: makeExternalLearnerAppCreateContentTypeResolveRedirector('assessments')
          }).
          when('/edit/assessments/:id', {
            template: require('../templates/partials/edit-assessment.html'),
            title: defaultTitle + ' :: Edit Assessment',
            resolveRedirectTo: makeExternalLearnerAppCreateContentTypeResolveRedirector('assessments')
          }).
           when('/edit/workshops', {
            template: require('../templates/partials/workshop-type-selection.html'),
            title: defaultTitle + ' :: Edit Workshop',
            reloadOnSearch: false
          }).
          when('/edit/basic-workshops', {
            template: require('../templates/partials/edit-workshop.html'),
            title: defaultTitle + ' :: Edit Workshop',
            reloadOnSearch: false
          }).
          when('/edit/workshops/:id', {
            template: require('../templates/partials/edit-workshop.html'),
            title: defaultTitle + ' :: Edit Workshop',
            reloadOnSearch: false,
            reloadOnUrl: false
          }).
          when('/edit/multi-session-workshops/:id?', {
            template: require('../templates/partials/edit-multi-session-workshop.html'),
            title: defaultTitle + ' :: Edit Multi Session Workshop',
            reloadOnSearch: false,
            reloadOnUrl: false
          }).
          when('/edit/multi-session-workshops/:id/session', {
            template: require('../templates/partials/edit-workshop.html'),
            title: defaultTitle + ' :: Edit Session',
            reloadOnSearch: false
          }).
          when('/edit/multi-session-workshops/:id/session/:sessionid', {
            template: require('../templates/partials/edit-workshop.html'),
            title: defaultTitle + ' :: Edit Session',
            reloadOnSearch: false
          }).
          when('/view/multi-session-workshops/:id', {
            template: require('../templates/partials/view-multi-session-workshop.html'),
            title: defaultTitle,
            reloadOnSearch: false,
            resolveRedirectTo: makeExternalLearnerAppContentTypeResolveRedirector('msw')
          }).
          when('/edit/survey', {
            template: require('../templates/partials/edit-survey.html'),
            title: defaultTitle + ' :: Create Survey'
          }).
          when('/edit/survey/:id', {
            template: require('../templates/partials/edit-survey.html'),
            title: defaultTitle + ' :: Edit Survey'
          }).
          when('/edit/tracks', {
            template: require('../templates/partials/edit-track.html'),
            title: defaultTitle + ' :: Edit Course', 
            resolveRedirectTo: makeExternalLearnerAppCreateContentTypeResolveRedirector('tracks')
          }).
          when('/edit/tracks/:id', {
            template: require('../templates/partials/edit-track.html'),
            title: defaultTitle + ' :: Edit Course',
            resolveRedirectTo: makeExternalLearnerAppCreateContentTypeResolveRedirector('tracks')
          }).
          when('/edit/groups', {
            template: require('../templates/partials/edit-group.html'),
            title: defaultTitle + ' :: Edit Group'
          }).
          when('/edit/groups/:id', {
            template: require('../templates/partials/edit-group.html'),
            title: defaultTitle + ' :: Edit Group'
          }).
          when('/view/groups/:id', {
            template: require('../templates/partials/view-group.html'),
            title: defaultTitle + ' :: View Group',
            reloadOnSearch: false,
            reloadOnUrl: false
          }).
          when('/edit/quizzes', {
            template: require('../templates/partials/edit-quiz.html'),
            title: defaultTitle + ' :: Edit Quiz'
          }).
          when('/edit/quizzes/:id', {
            template: require('../templates/partials/edit-quiz.html'),
            title: defaultTitle + ' :: Edit Quiz'
          }).
          when('/edit/polls', {
            template: require('../templates/partials/edit-poll.html'),
            title: defaultTitle + ' :: Edit Poll'
          }).
          when('/edit/polls/:id', {
            template: require('../templates/partials/edit-poll.html'),
            title: defaultTitle + ' :: Edit Poll'
          }).
          when('/edit/users/:id', {
            template: require('../templates/partials/admin-user-manage.html'),
            title: defaultTitle + ' :: Edit User',
            resolveRedirectTo: makeExternalLearnerAppAdminUsersResolveRedirector('editUser')
          }).
          when('/suspended/:id', {
            template: require('../templates/partials/suspended-user.html'),
            title: defaultTitle + ' :: Suspended User',
            resolveRedirectTo: makeExternalLearnerAppAdminUsersResolveRedirector('suspendedUser')
          }).
          when('/edit/workflows', {
            template: require('../templates/partials/edit-workflow.html'),
            title: defaultTitle + ' :: Edit Workflow'
          }).
          when('/edit/workflows/:id', {
            template: require('../templates/partials/edit-workflow.html'),
            title: defaultTitle + ' :: Edit Workflow'
          }).
          when('/edit/presentations', {
            template: require('../templates/partials/edit-presentation.html'),
            title: defaultTitle + ' :: Edit Presentation'
          }).
          when('/edit/presentations/:id', {
            template: require('../templates/partials/edit-presentation.html'),
            title: defaultTitle + ' :: Presentation File'
          }).
          when('/edit/courses', {
            template: require('../templates/partials/course-selection.html'),
            title: defaultTitle + ' :: Edit Course',
            resolveRedirectTo: makeExternalLearnerAppCreateContentTypeResolveRedirector('courses')
            
          }).
          when('/users/add/csv', {
            template: require('../templates/partials/add-users-csv.html'),
            title: defaultTitle + ' :: Add Users',
            resolveRedirectTo: makeExternalLearnerAppAdminUsersResolveRedirector('addUsersBulk')
          }).
          when('/dashboard/:location?', {
            template: require('../templates/partials/dashboard.html'),
            title: defaultTitle + ' :: My Dashboard',
            reloadOnUrl: false,
            resolveRedirectTo: makeExternalLearnerAppResolveRedirector('dashboard')
          }).
          when('/signin', {
            template: require('../templates/partials/signin.html'),
            title: defaultTitle + ' :: Sign In',
            resolveRedirectTo: makeExternalLearnerAppResolveRedirector('login', true)
          }).
          when('/register-with-userid', {
            template: require('../templates/partials/signin.html'),
            title: defaultTitle + ' :: Register'
          }).
          when('/forgot', {
            template: require('../templates/partials/signin.html'),
            title: defaultTitle + ' :: Password Recovery'
          }).
          when('/acceptinvite', {
            template: require('../templates/partials/signin.html'),
            title: defaultTitle + ' :: Accept Your Invite'
          }).
          when('/resetpassword', {
            template: require('../templates/partials/signin.html'),
            title: defaultTitle + ' :: Reset Password'
          }).
          when('/accept', {
            template: require('../templates/partials/signin.html'),
            title: defaultTitle + ' :: Accept Your Invite'
          }).
          when('/reset', {
            template: require('../templates/partials/signin.html'),
            title: defaultTitle + ' :: Reset Password'
          }).
          when('/register', {
            template: require('../templates/partials/signin.html'),
            title: defaultTitle + ' :: Register'
          }).
          when('/saml-transition', {
            template: require('../templates/partials/signin.html'),
            title: defaultTitle + ' :: Sign In'
          }).
          when('/saml-transition-error', {
            template: require('../templates/partials/saml-errors.html'),
            title: defaultTitle + ' :: Sign In Error'
          }).
          when('/oauth-transition', {
            template: require('../templates/partials/signin.html'),
            title: defaultTitle + ' :: Sign In'
          }).
          when('/users/add/', {
            template: require('../templates/partials/users-add.html'),
            title: defaultTitle + ' :: Add a User',
            resolveRedirectTo: makeExternalLearnerAppAdminUsersResolveRedirector('addUsersSingle')
          }).
          when('/host/track/:id', {
            template: require('../templates/partials/host-track.html'),
            title: defaultTitle + ' :: Track Host'
          }).
          when('/host/tracks/:id', {
            template: require('../templates/partials/host-track.html'),
            title: defaultTitle + ' :: Track Host'
          }).
          when('/host/scorm/:id', {
            template: require('../templates/partials/host-scorm.html'),
            title: defaultTitle + ' :: SCORM Host'
          }).
          when('/host/workshop-instance/zoom-history/:id', {
            template: require('../templates/partials/host-workshop-zoom.html'),
            title: defaultTitle + ' :: Workshop Host'
          }).
          when('/host/workshops/:id', {
            template: require('../templates/partials/host-workshop.html'),
            title: defaultTitle + ' :: Workshop Host'
          }).
          when('/host/workshops/:id/instance/:instanceId', {
            template: require('../templates/partials/host-workshop.html'),
            title: defaultTitle + ' :: Workshop Host'
          }).
          when('/host/multi-session-workshops/:id', {
            template: require('../templates/partials/host-multi-session-workshop.html'),
            title: defaultTitle + ' :: Multi Session Workshop Host'
          }).
          when('/host/multi-session-workshop-sessions/:mswid/session/:id', {
            template: require('../templates/partials/host-multi-session-workshop-session.html'),
            title: defaultTitle + ' :: Multi Session Workshop Session Host'
          }).
          when('/host/articles/:id', {
            template: require('../templates/partials/host-content.html'),
            title: defaultTitle + ' :: Article Host'
          }).
          when('/host/videos/:id', {
            template: require('../templates/partials/host-content.html'),
            title: defaultTitle + ' :: Video Host'
          }).
          when('/host/files/:id', {
            template: require('../templates/partials/host-content.html'),
            title: defaultTitle + ' :: File Host'
          }).
          when('/host/imported-content/:id', {
            template: require('../templates/partials/host-imported-content.html'),
            title: defaultTitle + ' :: Third-Party Content Host'
          }).
          when('/host/journeys/:id', {
            template: require('../templates/partials/host-journeys.html'),
            title: defaultTitle + ' :: Journey Host'
          }).
          when('/host/presentations/:id', {
            template: require('../templates/partials/host-content.html'),
            title: defaultTitle + ' :: Presentation Host'
          }).
          when('/host/assessments/:id', {
            template: require('../templates/partials/host-assessment.html'),
            title: defaultTitle + ' :: Assessment Host'
          }).
          when('/host/surveys/:id',{
              template:  require('../templates/partials/host-surveys.html'),
            title: defaultTitle + ' :: Surveys Host'
          }).
          when('/saml', {
            template: require('../templates/partials/saml.html'),
            title: defaultTitle + ' :: Saml Setup'
          }).
          when('/modules', {
            template: require('../templates/partials/todo-module-overview.html'),
            title: defaultTitle + ' :: Modules'
          }).
          when('/overview/admin', {
            template: require('../templates/partials/overview-admin.html'),
            title: defaultTitle + ' :: Admin Overview'
          }).
          when('/overview/content', {
            template: require('../templates/partials/overview-content.html'),
            title: defaultTitle + ' :: Content Overview'
          }).
          when('/overview/journeys', {
            template: require('../templates/partials/overview-journeys.html'),
            title: defaultTitle + ' :: Journey Overview'
          }).
          when('/overview/polls', {
            template: require('../templates/partials/overview-polls.html'),
            title: defaultTitle + ' :: Engage Overview'
          }).
          when('/overview/workshops', {
            template: require('../templates/partials/overview-workshops.html'),
            title: defaultTitle + ' :: Workshops Overview'
          }).
          when('/overview/assessments', {
            template: require('../templates/partials/overview-assessments.html'),
            title: defaultTitle + ' :: Assessments Overview'
          }).
          when('/overview/assignments', {
            template: require('../templates/partials/overview-assignments.html'),
            title: defaultTitle + ' :: Assignments Overview'
          }).
          when('/overview/settings/:type?', {
            template: require('../templates/partials/overview-settings.html'),
            title: defaultTitle + ' :: Settings Overview',
            resolveRedirectTo: makeExternalLearnerAppAdminSettingsResolveRedirector()
          }).
          when('/overview/users', {
            template: require('../templates/partials/overview-users.html'),
            title: defaultTitle + ' :: Users Overview',
            resolveRedirectTo: makeExternalLearnerAppAdminUsersResolveRedirector('userOverview')
          }).
          when('/overview/workflows', {
            template: require('../templates/partials/overview-workflows.html'),
            title: defaultTitle + ' :: Workflows Overview'
          }).
          when('/manager', {
            template: require('../templates/partials/manager-reports.html'),
            title: defaultTitle + ' :: Manager',
            reloadOnSearch: false
          }).
          when('/overview/reports', {
            template: require('../templates/partials/overview-reports.html'),
            title: defaultTitle + ' :: Reports',
            reloadOnSearch: false
          }).
          when('/overview/surveys', {
          template: require('../templates/partials/overview-surveys.html'),
          title: defaultTitle + ' :: Surveys',
          reloadOnSearch: false
          }).
          when('/overview/reports/dashboard-charts', {
            template: require('../templates/partials/overview-reports-dashboard-charts.html'),
            title: defaultTitle + ' :: Dashboard Charts Overview'
          }).
          when('/overview/badges', {
            template: require('../templates/partials/overview-badges.html'),
            title: defaultTitle + ' :: Badges',
            reloadOnSearch: false
          }).
          when('/overview/badges/:id', {
            template: require('../templates/partials/edit-badge.html'),
            title: defaultTitle + ' :: Edit Badge',
            reloadOnSearch: false
          }).
          when('/create/badges', {
            template: require('../templates/partials/edit-badge.html'),
            title: defaultTitle + ' :: Create Badge',
            reloadOnSearch: false
          }).
          when('/404', {
            template: require('../templates/partials/404.html'),
            title: defaultTitle + ' :: Page Not Found'
          }).
          when('/manage/content', {
            redirectTo: '/overview/content'
          }).
          when('/manage/tracks', {
            redirectTo: '/overview/content'
          }).
          when('/manage/users', {
            redirectTo: '/overview/users'
          }).
          when('/continu/categories', {
            template: require('../templates/partials/manage-categories.html'),
            title: defaultTitle + ' :: Categories'
          }).
          when('/translation', {
            template: require('../templates/partials/translation.html'),
            title: defaultTitle + ' :: Translations'
          }).
          when('/profile/:profileid', {
            template: require('../templates/partials/profile-display.html'),
            title: defaultTitle + ' :: Profile'
          }).
          when('/results/polls/:id', {
            template: require('../templates/partials/results-landing.html'),
            title: defaultTitle + ' :: Poll Results'
          }).
          when('/overview/reports', {
            template: require('../templates/partials/overview-reports.html'),
            title: defaultTitle + ' :: Reports Overview',
            resolveRedirectTo: makeExternalLearnerAppAdminReportsResolveRedirector()
          }).
          when('/overview/reports-old', {
            template: require('../templates/partials/pre-cooked.html'),
            title: defaultTitle + ' :: Reports Overview'
          }).
          when('/edit/report', {
            template: require('../templates/partials/edit-report.html'),
            title: defaultTitle + ' :: Create a Report'
          }).
          when('/edit/report/:id', {
            template: require('../templates/partials/edit-report.html'),
            title: defaultTitle + ' :: Edit Report'
          }).
          when('/google-redirect', {
            template: require('../templates/partials/google-redirect.html'),
            title: defaultTitle + ' :: Redirect'
          }).
          when('/meets-redirect', {
            template: require('../templates/partials/meets-redirect.html'),
            title: defaultTitle + ' :: Redirect'
          }).
          when('/google-calendar-integrate', {
            template: require('../templates/partials/google-calendar-integrate.html'),
            title: defaultTitle + ' :: GCal'
          }).
          when('/microsoft-redirect', {
            template: require('../templates/partials/microsoft-redirect.html'),
            title: defaultTitle + ' :: Microsoft Teams Integration'
          }).
          when('/please-wait-transferring', {
            template: require('../templates/partials/transferring.html'),
            title: defaultTitle + ' :: Redirect'
          }).
          when('/please-wait-transferring-public', {
            template: require('../templates/partials/transferring.html'),
            title: defaultTitle + ' :: Redirect'
          }).
          otherwise({
            redirectTo: '/signin',
            title: defaultTitle + ' :: Sign In'
          })
          ;
    }]);
  /**
   * Configure the authorization interceptor for the headers
   * @argument {Object} $httpProvider injected to change the default behavior of the $http service
   */
  app.config(['$httpProvider', function($httpProvider) {
      $httpProvider.interceptors.push('authInterceptor');
    }]);

  /**
   * Overriding Angular 1.6's hash prefix default of #! to just #.
   */
  app.config(['$locationProvider', function($locationProvider) {
    $locationProvider.hashPrefix('');
  }]);

  app.filter('trustedResource', ['$sce', function($sce) {
    return function(val) {
        return $sce.trustAsResourceUrl(val);
    };
  }]);

  /**
   * Modify $location.path to have an option to not reload
   * @argument {Object} $location injected to change the default behavior of the $location service
   * @argument {Object} $route injected to change to find route
   * @argument {Object} $rootScope injected to change to gain access to the $rootScope
   */
  app.run(['$route', '$rootScope', '$document', '$location', '$window', 'Application', 'Authorization', 'i18n', '$anchorScroll', function($route, $rootScope, $document, $location, $window, Application, Authorization, i18n, $anchorScroll) {
      //Initialize the analytics providers that are defined in Application.js
      Application.analyticsProvider.init();

      function setLanguage () {
        if (Authorization.getAuthToken() && Authorization.getAuthToken().user && Authorization.getAuthToken().user.language) {
          i18n.language(Authorization.getAuthToken().user.language);
        }
      };

      $document[0].addEventListener("visibilitychange", function() {
        Authorization.activityCheck();
      });

      const onFocus = function () {
        Authorization.activityCheck();
      };
      var win = angular.element($window);
      win.on("focus", onFocus);

      $rootScope.$on("$routeChangeStart", Authorization.activityCheck);

      $rootScope.$on("$routeChangeSuccess", function(currentRoute, previousRoute){
        if (window.ga) {
          window.ga('set', 'page', $location.path());
          window.ga('send', 'pageview');
        }
        $rootScope.title = $route.current.title;
        var preRedirect = Application.navigation.getPath();
        setLanguage();
        if (!Application.navigation.isRouteSecure(preRedirect)) {
          return;
        }
        if (Application.navigation.isRouteSecure()) {
          Authorization.setActive();
        }
        Application.intercom.update();
        $anchorScroll();
      });
    }]);

  /**
   * Filter for rounding numbers
   */
  app.filter('round', [ '$filter', function ($filter) {
    return function (input) {
      if (!input || !parseFloat(input)) {
        return 0;
      }
      return Math.round(parseFloat(input));
    };
  }]);
  /**
   * Filter for entity rendering (in Markup {{ '&#x1F601;' | unsafe }} will result in a happy face - works with HTML too! )
   */
  app.filter('unsafe',[ '$sce', function($sce) {
    return function(val) {
      return $sce.trustAsHtml(val);
    };
  }]);

  /**
  * Filter for capitalizing text (in Markup {{ 'word' | capitalize}} will result in "Word"  )
  */
  app.filter('capitalize', function() {
    return function(input) {
      return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
    };
  });
  app.filter('mentionReplace', function() {
    return function(input) {
      if (!input || typeof input !== 'string') {
        return input;
      }
      var modified = input.slice(0);
      var items = [];
      var pair = [];
      for (var i = 0; i < modified.length; i++) {
        if (!pair.length) {
          if (modified[i] && modified[i] === '<' && modified[i + 1] && modified[i + 1] === ':') {
            pair.push(i);
            continue;
          }
        }
        if (pair.length) {
          if (modified[i] === '>') {
            pair.push(i + 1);
            items.push(pair);
            pair = [];
          }
        }
      }
      if (items.length) {
        for (var j = items.length - 1; j >= 0; j--) {
          var user = modified.substring(items[j][0], items[j][1]);
          if (user && typeof user === 'string') {
            var splitUser = user.split(':');
            if (splitUser[1] && splitUser[2]) {
              var newItem = '<span class="mention--item" data-user="' + splitUser[2].slice(0, -1) + '">@' + splitUser[1].split('.').join(' ') + '</span>';
              modified = modified.replace(user, newItem);
            }
          }
        }
      }
      return modified;
    };
  });
  app.filter('commentTitleSnip', function() {
    return function(input) {
      var shortenAfter = 23;
      if (!input || typeof input !== 'string') {
        return '';
      }
      if (input.length < shortenAfter) {
        return input;
      }
      return input.substring(0, shortenAfter) + ' (...)';
    };
  });
  

  angular.element(document).ready(function() {
    const configRequest = new XMLHttpRequest();
    configRequest.open('GET', 'v3/config', true);
    configRequest.setRequestHeader('Content-Type', 'application/json');
    configRequest.onload = function () {
      if (this.status >= 200 && this.status < 400) {
        const data = JSON.parse(this.response);
        setupApp.config(['appConfigurationProvider', function(appConfigurationProvider) {
          appConfigurationProvider.initialize(data);
        }]);

        angular.bootstrap(document, ['learn-app']);

      }
    };
    configRequest.onerror = function () {
      alert('An error occurred retrieving your site configuration, please contact your administrator.');
    };
    configRequest.send();
  });

})();
